import type { DiscountConfigType } from "@/features/cart/types/discount.type";
import { GET } from "@/lib/methods";

export const getDiscountsConfig = ({
  params,
  id,
  client = false,
}: {
  params?: RequestInit;
  id: string;
  client?: boolean;
}) => {
  const requestParams = {
    next: client
      ? {}
      : {
          tags: ["discounts-config", id],
          revalidate: 3600,
        },
    ...params,
  };

  const res = GET<DiscountConfigType>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/promotions/config/${id}`,
    params: requestParams,
  });

  return res;
};
